import {Component, Injector, Input} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {FormControl, FormGroup} from '@angular/forms';
import {OrganizationRegistrationService} from './organization-registration.service';
import {BusinessStructureProvider} from '@providers/business-structure/business-structure.provider';
import {AuthService} from '@services/auth.service';

@Component({
    selector: 'app-manual-registration',
    templateUrl: 'manual-registration.component.html',
})

export class ManualRegistrationComponent extends FrontendFormComponent {

    @Input() initialValues = null;

    form = new FormGroup({
        email: new FormControl(''),
        password: new FormControl(''),

        /**
         * Поля, которые могут быть предзаполненными после валидации ИНН
         */
        title: new FormControl(''),
        short_title: new FormControl(''),
        business_structure_id: new FormControl(''),
        INN: new FormControl(''),
        full_name_signer: new FormControl(''),
        job_signer: new FormControl(''),
        OGRN: new FormControl(''),
        OKPO: new FormControl(''),
        OKVED: new FormControl(''),
        KPP: new FormControl(''),
        incorporation_date: new FormControl(''),
    });

    constructor(
        injector: Injector,
        public businessStructureProvider: BusinessStructureProvider,
        public formService: OrganizationRegistrationService,
        private authService: AuthService,
    ) {
        super(injector);
    }

    init() {
        if (this.initialValues) {
            this.form.patchValue(this.initialValues);
        }
    }

    saveHandler(token: string) {
        this.authService.login(token);
    }

    /**
     * Отключаем уведомление об ошибках в полях, переопределяя родительский метод
     * @param error
     * @returns {null}
     */
    showErrorsNotification(error) {
        return null;
    }
}
